import {
  ConnectedAppProvider,
  ConnectedAppReservedProviderTypes
} from '~/api/types/connectedAppProviders.ts';
import { AppErrors } from '~/components/ErrorBoundaries/utils.ts';
import { ConnectionData } from '~/api/types/connectionData.ts';
import { getLocalizedString } from '~/i18n/utils.ts';

enum AgentAuthTabTypes {
  CONNECTIONS = 'connections',
  CONNECTED_ACCOUNTS = 'connected-accounts'
}

const getConnectedAppProviderDetails = (
  providers: ConnectedAppProvider[],
  providerKey: string
): ConnectedAppProvider => {
  if (!providers.length) {
    throw new Error(AppErrors.CONNECTED_APP_PROVIDER_LIST_EMPTY);
  }
  const filteredProvider = providers.filter(
    ({ identifier }) => identifier === providerKey
  )?.[0];
  if (!filteredProvider) {
    throw new Error(AppErrors.CONNECTED_APP_PROVIDER_NOT_FOUND);
  }
  return filteredProvider;
};

const isOauthConnectedApp = (connectedApp: ConnectionData) => {
  return (
    connectedApp?.type === (ConnectedAppReservedProviderTypes.OAUTH2 as string)
  );
};

const getAppTitle = ({
  intl,
  tabType
}: {
  intl: any;
  tabType: AgentAuthTabTypes;
}) => {
  const titleMap: Record<AgentAuthTabTypes, string> = {
    [AgentAuthTabTypes.CONNECTIONS]: getLocalizedString(
      'page_titles.connect_integrations',
      { intl }
    ),
    [AgentAuthTabTypes.CONNECTED_ACCOUNTS]: getLocalizedString(
      'page_titles.connected_accounts',
      { intl }
    )
  };

  return (
    (tabType && titleMap?.[tabType]) ||
    getLocalizedString('page_titles.agent_auth', { intl })
  );
};

export {
  AgentAuthTabTypes,
  getConnectedAppProviderDetails,
  isOauthConnectedApp,
  getAppTitle
};
